<template>
	<div>
		<OverviewTitleBox :title="'SUPPORT'" class="mb-3"/>
		<div class="" v-if="true">
			<H6 class="title-section">SUPPORT</H6>
		</div>

		<div class="row mb-4">
			<div class="col-md-4">
				<InfoCardComp icon="fa-hourglass-end" prefix="INVOICE OVERDUE" comp=-1 unit="" :data="invoice.overdue.comp" infocol="DT" valuecol="Cnt" url="/vendor"/>
			</div>
		</div>

	</div>
</template>

<script>
import Support from '@/components/page/Support.js'
import OverviewTitleBox from '@/views/component/OverviewTitleBox.vue'
//import InfoCardComp from '@/views/pages/InfoCardComp.vue'

export default{
	extends: Support,
	components:{
		//InfoCardComp
		OverviewTitleBox,
	},
    mounted(){
		this.loadInvoice();
    },
    methods:{
	}
}

</script>
